import React from 'react';
import { Typography } from '@material-ui/core';

const TdsPercentage = ({ tdsPercentage }) => (
  <div>
    <Typography>TDS %</Typography>
    <Typography style={{ marginTop: '10px' }}>
      {tdsPercentage === 'INVALID PAN' ? tdsPercentage : `${tdsPercentage} %`}
    </Typography>
  </div>
);

export default TdsPercentage;
